export default __webpack_public_path__ + "static/media/login.24119542.svg";